import { Injectable } from '@angular/core';
import { Fido2Helper } from '../helper/fido2.helper';
import { IError, IFido2ConfigurePayload, IFriendlyNamePayload, ILocationInfo, IMFAData } from '../model/fido2.model';
import { COOKIE } from '../helper/constants';
import { ApiFido2Service } from './api.fido2.service';
import { BehaviorSubject, of } from 'rxjs';
import { catchError, mergeMap, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class Fido2Service {
  navigator: any = window.navigator;
  errorMessage$ = new BehaviorSubject({});

  constructor(private fidoHelper: Fido2Helper, private fidoApi: ApiFido2Service) {}

  initiateFido2(trackId: string, sub: string): Promise<any> {
    // initiate fido2
    return this.fidoApi
      ._initiateFido2(trackId, 'fido2')
      .toPromise()
      .then((res) => {
        if (res && res.success) {
          // initiate fido2 setup
          return this.initFido2Setup(<IMFAData>res.data, sub)
            .then((res: IFido2ConfigurePayload | IError) => {
              if ((res as IFido2ConfigurePayload).exchange_id) {
                // enroll fido2
                return this.enrollFido2(<IFido2ConfigurePayload>res)
                  .then((res: any | IError) => {
                    if ((res as IError).error) {
                      return Promise.reject(res);
                    } else {
                      return Promise.resolve(res);
                    }
                  })
                  .catch((err: IError) => {});
              } else {
                console.log(res);
                return Promise.reject(res);
              }
            })
            .catch((error: IError) => {
              return Promise.reject(error);
            });
        } else {
          const error: IError = {
            message: `something went wrong while initiating fido2! [Error]:${JSON.stringify(res)}`,
            error: {
              status: 400,
              success: false,
            },
          };
          console.log(error);
          return Promise.reject(error);
        }
      });
  }

  _getDeviceId = (): string => {
    return this._getCookie(COOKIE.CIDAAS_DR);
  };

  // get Cookie
  _getCookie = (name: string): string => {
    if (document.cookie.length > 0) {
      let c_end,
        c_start = document.cookie.indexOf(name + '=');
      if (c_start != -1) {
        c_start = c_start + name.length + 1;
        c_end = document.cookie.indexOf(';', c_start);
        if (c_end == -1) {
          c_end = document.cookie.length;
        }
        return unescape(document.cookie.substring(c_start, c_end));
      }
    }
    return '';
  };

  // get location info
  _getLocation = () => {
    const location: ILocationInfo = { lat: '', lon: '' };
    try {
      if (window.navigator && window.navigator.geolocation) {
        window.navigator.geolocation.getCurrentPosition(
          (position) => {
            location.lat = position.coords.latitude + '';
            location.lon = position.coords.longitude + '';
          },
          (error) => {
            location.lat = '';
            location.lon = '';
          }
        );
      }
    } catch (error) {
      location.lat = '';
      location.lon = '';
    }
    return location;
  };

  // init fido setup
  initFido2Setup = (mfaData: IMFAData, userSub: string): Promise<IFido2ConfigurePayload | IError> => {
    // create public key for fido
    const publicKey = this.fidoHelper.preformatMakeCredReq(mfaData.fido2_entity.server_challenge);
    // enrollFidoPayload
    let enrollFidoPayload = <IFido2ConfigurePayload>{};

    // checking navigator and
    if (this.navigator.credentials && this.navigator.credentials.create) {
      return this.navigator.credentials
        .create({ publicKey })
        .then((response) => {
          console.log(response);
          const makeCredResponse = this.fidoHelper.publicKeyCredentialToJSON(response);
          enrollFidoPayload = {
            sub: userSub,
            exchange_id: mfaData.exchange_id.exchange_id,
            fido2_client_response: {
              client_response: makeCredResponse,
              fidoRequestId: mfaData.fido2_entity.fidoRequestId,
            },
          };
          return Promise.resolve(enrollFidoPayload);
        })
        .catch((err) => {
          console.log(err);
          const error: IError = {
            message: err?.message,
            error: {
              status: 400,
              success: false,
            },
          };
          return Promise.reject(error);
        });
    } else {
      const error: IError = {
        message: 'Facing issues while retrieving navigator details.',
        error: {
          status: 400,
          success: false,
        },
      };
      return Promise.reject(error);
    }
  };

  // enroll fido2
  // enroll fido setup
  enrollFido2 = (payload: IFido2ConfigurePayload): Promise<any | IError> => {
    return this.fidoApi
      ._configureFido2(payload, 'fido2')
      .toPromise()
      .then(
        (data: any) => {
          if (data && data.success) {
            return Promise.resolve(data.data);
          } else {
            const error: IError = {
              message: 'Facing issues while configuring fido2.',
              error: {
                status: 400,
                success: false,
              },
            };
            return Promise.reject(error);
          }
        },
        (err: IError) => {
          const error: IError = {
            message: err?.message,
            error: {
              status: 400,
              success: false,
            },
          };
          return Promise.reject(error);
        }
      );
  };

  _saveFriendlyName = (paylaod:IFriendlyNamePayload, track_id:string, method:string) =>{
    return this.fidoApi._configureFido2Name(paylaod, track_id, method)
  }
}
